module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av768-f86d1f590fe30c5562209c6a4ce67380.jpg";